









import Vue from "vue";
export default Vue.extend({
  props: {
    placeholder: {
      type: String,
      default: ""
    },
    rowNum: {
      type: String,
      default: "2"
    },
    value: {
      type: String,
      default: ""
    }
  },
  computed: {
    textareaClass(): string {
      return `textarea-${this.rowNum}`;
    },
    text: {
      get(): string {
        return this.value;
      },
      set(value: string) {
        this.$emit("input", value);
      }
    }
  }
});
